import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';

import { Icon } from 'components';

class Pagination extends Component {
  static defaultProps = {
    current: 1,
    total: 1,
    per: 10,
  };

  handlePageUrl = page => {
    const url = this.props.location.pathname;
    const params = queryString.parse(this.props.location.search);

    if (Object.keys(params).indexOf('page') !== -1) {
      const queryString = Object.keys(params).map(param => {
        return param !== 'page' ? `${param}=${params[param]}` : `${param}=${page}`;
      });

      return `${url}?${queryString.join('&')}`;
    }

    return `${url}?page=${page}`;
  };

  render() {
    const { current } = this.props;

    return (
      <nav className="pagination">
        {current !== 1 ? (
          <Link to={this.handlePageUrl(current - 1)} className="pagination-arrow">
            <Icon name="caret-left" prefix="fa" />
          </Link>
        ) : (
          <span className="pagination-arrow disabled">
            <Icon name="caret-left" prefix="fa" />
          </span>
        )}

        <span className="pagination-page">{current}</span>

        {/*(current * per) < total ? (
          <Link to={this.handlePageUrl(current + 1)} className="pagination-arrow">
            <Icon name="caret-right" prefix="fa" />
          </Link>
        ) : (
          <span className="pagination-arrow disabled">
            <Icon name="caret-right" prefix="fa" />
          </span>
        )*/}
        <Link to={this.handlePageUrl(current + 1)} className="pagination-arrow">
          <Icon name="caret-right" prefix="fa" />
        </Link>
      </nav>
    );
  }
}

export default Pagination;
